<template>
  <view-container title="Your favourite combatants">
    <template v-slot:heading>
      Your favourites
    </template>

    <template v-slot:default>
      <item-animator :items="getFavourites" data-test="favouritesList">
        <template v-slot="item">
          <favourite :id="item.id" />
        </template>
      </item-animator>
    </template>

    <template v-slot:after>
      <a href="/" @click.prevent="$router.back()" class="py-4 inline-block">
        Go back
      </a>
    </template>
  </view-container>
</template>

<script>
import Favourite from '@/components/Favourite'
import ItemAnimator from '@/components/ItemAnimator'
import ViewContainer from '@/components/ViewContainer'

import { mapGetters } from 'vuex'

export default {
  components: {
    Favourite,
    ItemAnimator,
    ViewContainer,
  },
  computed: {
    ...mapGetters(`favourites`, [`uid`, `getFavourites`]),
  },
}
</script>
